// http-Request
const tools = {
    // 职位申请
    applyDone: function (data, instance) {
        const baseURL = instance.$axios.defaults.baseURL;
        instance.$axios({
            url: '/xhorse/pos/apply-done',
            baseURL: baseURL,
            method: 'post',
            data: data,
            withCredentials: false,
            responseType: 'json',
            transformRequest: [function (data) {
                return instance.$qs.stringify(data);
            }],
            headers: {'X-Requested-With': 'XMLHttpRequest', 'Content-type': 'application/x-www-form-urlencoded'},
            onUploadProgress: function (progressEvent) {
                //console.log(progressEvent)
                /*let loadPer = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
                 const posLoader = instance.$loading({
                 target: '.list-con',
                 /!*   target: '.app',*!/
                 fullscreen: true,
                 background: 'rgba(251,251,251,0.4)'
                 });
                 if (loadPer >= 100) {
                 posLoader.close();
                 }*/
            },
        }).then(res => {
            //console.log(res)
            const code = res.data.status;
            const message = res.data.message;
            if (code == '1001') {
                /*instance.$message.success('恭喜你，申请成功。我们将在五个工作日内联系你，请保持电话畅通，谢谢。');*/
                instance.$emit('go', {
                    type: 'notice', val: {
                        activeName: 4
                    }
                })
                Object.assign(instance.$data.db.form, instance.$options.data().db.form);
                Object.assign(instance.$data.conf.upload, instance.$options.data().conf.upload);
            } else {
                instance.$message.error(message);
            }
        }).catch(err => {
            //console.log(err)
            instance.$message.error('The system is abnormal, please try again!');
        });
    },
    // 职位详情
    getPosDetail: function (data, instance) {
        const baseURL = instance.$axios.defaults.baseURL;
        instance.$axios({
            url: '/xhorse/pos/details',
            baseURL: baseURL,
            method: 'post',
            data: data,
            withCredentials: false,
            responseType: 'json',
            transformRequest: [function (data) {
                return instance.$qs.stringify(data);
            }],
            headers: {'X-Requested-With': 'XMLHttpRequest', 'Content-type': 'application/x-www-form-urlencoded'},
            onUploadProgress: function (progressEvent) {
                //console.log(progressEvent)
                let loadPer = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
                const posLoader = instance.$loading({
                    target: '.list-con',
                    /*   target: '.app',*/
                    fullscreen: true,
                    background: 'rgba(251,251,251,0.4)'
                });
                if (loadPer >= 100) {
                    posLoader.close();
                }
            },
        }).then(res => {
            //console.log(res)
            const data = res.data.data;
            instance.db.responsibility = data.responsibility;
            instance.db.requirement = data.requirement;
        }).catch(err => {
            //console.log(err)
            instance.db.responsibility = [];
            instance.db.requirement = [];
        });
    },
    // 职位列表
    getPos: function (data, instance) {
        const baseURL = instance.$axios.defaults.baseURL;
        instance.$axios({
            url: '/xhorse/pos/links',
            baseURL: baseURL,
            method: 'post',
            data: data,
            withCredentials: false,
            responseType: 'json',
            transformRequest: [function (data) {
                return instance.$qs.stringify(data);
            }],
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-type': 'application/x-www-form-urlencoded'
            },
            onUploadProgress: function (progressEvent) {
                //console.log(progressEvent)
                let loadPer = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
                const posLoader = instance.$loading({
                    target: '.list-body',
                    /*   target: '.app',*/
                    fullscreen: true,
                    background: 'rgba(251,251,251,0.4)'
                });
                if (loadPer >= 100) {
                    posLoader.close();
                }
                
            },
        }).then(res => {
            const list = res.data.data.list;
            const page = res.data.data.page;
            instance.posData = list;
            if (list.length < 1) {
                instance.page.currentPage = 0;
                instance.page.total = 0;
            } else {
                instance.page.currentPage = page.currentPage;
                instance.page.total = page.total;
                instance.page.pageSize = page.pageSize;
            }
            //console.log(page)
        }).catch(err => {
            //console.log(err);
            instance.posData = [];
            instance.page.currentPage = 0;
            instance.page.total = 0;
        });
    },
    
    // 获取国家地区/省/市 列表
    
    getRegion(data, instance) {
        const baseURL = instance.$axios.defaults.baseURL;
        instance.$axios({
            url: '/xhorse/assis/nation-code',
            baseURL: baseURL,
            method: 'post',
            data: data,
            withCredentials: false,
            responseType: 'json',
            transformRequest: [function (data) {
                return instance.$qs.stringify(data);
            }],
            headers: {'X-Requested-With': 'XMLHttpRequest', 'Content-type': 'application/x-www-form-urlencoded'},
            onUploadProgress: function (progressEvent) {
                //console.log(progressEvent)
            },
        }).then(res => {
            //console.log(res)
            if (parseInt(res.data.status) === 1001) {
                const list = res.data.data;
                const islEmpty = list.length <= 0;
                if (parseInt(data.regionId) === 0) {
                    instance.models.nations = list;
                    if (islEmpty) {
                        instance.models.nationDisable = true;
                    } else {
                        instance.models.nationDisable = false;
                    }
                } else {
                    instance.models.cities = list;
                    if (islEmpty) {
                        instance.models.cityDisable = true;
                    } else {
                        instance.models.cityDisable = false;
                    }
                }
            }
        }).catch(err => {
            //console.log(err);
        });
    }
    
};

export default tools;


// WEBPACK FOOTER //
// ./src/axios/index.js